/*
 * Action Types
 */
export enum PrintModelTypes {
  LIST_PRINT_MODELS_REQUEST = '@printModels/LIST_PRINT_MODELS_REQUEST',
  LIST_PRINT_MODELS_SUCCESS = '@printModels/LIST_PRINT_MODELS_SUCCESS',
  LIST_PRINT_MODELS_FAILURE = '@printModels/LIST_PRINT_MODELS_FAILURE',

  CREATE_PRINT_MODEL_REQUEST = '@printModels/CREATE_PRINT_MODEL_REQUEST',
  CREATE_PRINT_MODEL_SUCCESS = '@printModels/CREATE_PRINT_MODEL_SUCCESS',
  CREATE_PRINT_MODEL_FAILURE = '@printModels/CREATE_PRINT_MODEL_FAILURE',

  UPDATE_PRINT_MODEL_REQUEST = '@printModels/UPDATE_PRINT_MODEL_REQUEST',
  UPDATE_PRINT_MODEL_SUCCESS = '@printModels/UPDATE_PRINT_MODEL_SUCCESS',
  UPDATE_PRINT_MODEL_FAILURE = '@printModels/UPDATE_PRINT_MODEL_FAILURE',

  DELETE_PRINT_MODEL_REQUEST = '@printModels/DELETE_PRINT_MODEL_REQUEST',
  DELETE_PRINT_MODEL_SUCCESS = '@printModels/DELETE_PRINT_MODEL_SUCCESS',
  DELETE_PRINT_MODEL_FAILURE = '@printModels/DELETE_printModel_FAILURE',
}

/*
 * Data types
 */
export interface PrintModelInterface {
  id: string;
  name: string;
  operation: string;
  type?: string;
  blocks: string;
  status: number;
  createdAt: string;
  updatedAt: string;
  transportOperatorId: string;
}

export type BlockType =
  | 'text'
  | 'image'
  | 'divider'
  | 'qrcode'
  | 'space'
  | 'spacer'
  | 'list'
  | 'conditional'
  | 'row'
  | 'box'
  | 'line';

export const blockType = {
  text: 'text',
  image: 'image',
  divider: 'divider',
  qrcode: 'qrcode',
  space: 'space',
  spacer: 'spacer',
  list: 'list',
  conditional: 'conditional',
  row: 'row',
  box: 'box',
  line: 'line',
} as const;

export interface ReceiptComponent {
  id: string;
  type: BlockType;
  label: string;
  icon: string;
  disabled?: boolean;
  showIf?: string;
  children?: ReceiptComponent[];
  repeatable?: boolean;
  /** Shown in the list palette, but not auto-inserted when the parent list is added. */
  optional?: boolean;
}

export interface BlockPayload {
  type: BlockType;
  value?: string;
  size?: number;
  width?: number;
  height?: number;
  bold?: boolean;
  italic?: boolean;
  align?: 'LEFT' | 'CENTER' | 'RIGHT';
  showIf?: string;
  source?: string;
  children?: BlockPayload[];
  lines?: number;
  background?: string;
  color?: string;
  border?: boolean;
  radius?: number;
  padding?: number;
  margin?: number;
}

/** @deprecated use BlockPayload */
export interface TextBlockComponent {
  align: string;
  bold: boolean;
  size: number;
  type: string;
  value: string;
}

/*
 * State type
 */
export interface PrintModelState {
  readonly printModelsList: PrintModelInterface[];
  readonly printModelData: PrintModelInterface;
  readonly loading: boolean;
  readonly error: boolean;
}
